import MuiDialogActions from '@mui/material/DialogActions';
import { withStyles } from '@mui/styles';

const AddGpcDialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(3),
  },
}))(MuiDialogActions);

export default AddGpcDialogActions;
